import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import "./ScoringDetails.scss";
import TopSection from "./TopSection";
import BottomSection from "./BottomSection";
import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";
import { useRecoilValue } from "recoil";
import {
  scoringSubmit,
  switchProtocolType,
} from "../../../store/audit details/atom";
import submitGif from "../../../assets/img/submit.gif";
import AuditProtocolScoringExcel from "../../reusables/AuditProtocolScoringExcel";
import {login} from "../../auth/msalAuth";


const ScoringDetails = () => {
  const [scoringData, setScoringData] = useState(null);
  const [scoringLoading, setScoringLoading] = useState(false);
  const [scoringError, setScoringError] = useState(null);
  const [fsscScore, setFsscScore] = useState(null);
  const [qmsScore, setQmsScore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [isCertification, setIsCertification] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [auditDetailsData, setAuditDetailsData] = useState({});
  const [protocolDetails, setProtocolDetailsData] = useState({});
  const [attendiesInArrayFormat, setAttendiesInArrayFormat] = useState([]);
    const [unitDetails, setUnitDetails] = useState([]);
    const [unitIndex, setUnitIndex] = useState("");
    const [error, setError] = useState(false);

  console.log("isCertification", isCertification);

  const getSotredProtocolType = useRecoilValue(switchProtocolType);

  console.log("typeeeee", getSotredProtocolType);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const scoringSubmitValue = useRecoilValue(scoringSubmit);

  const [searchParams] = useSearchParams();
  const auditNumber = searchParams.get("auditNumber");
  // const auditNumber = "2025-0082";

  function transformData(inputArray) {
    if (!Array.isArray(inputArray) || inputArray.length === 0) return [];

    const data = inputArray[0]; // Extract first object

    return {
      transformedData: [
        {
          id: 1,
          results: "Criticals",
          numOfNonComf: data?.critical ? String(data.critical) : 0,
          nonComfPoints: data?.criticalScore ? String(data.criticalScore) : 0,
        },
        {
          id: 2,
          results: "Majors",
          numOfNonComf: data?.major ? String(data.major) : 0,
          nonComfPoints: data?.majorScore ? String(data.majorScore) : 0,
        },
        {
          id: 3,
          results: "Minors",
          numOfNonComf: data?.minor ? String(data.minor) : 0,
          nonComfPoints: data?.minorScore ? String(data.minorScore) : 0,
        },
      ],
      totalNonConformanceScore: data?.totalNonConformanceScore,
      isFfscCertificationRecommended: data?.isFfscCertificationRecommended,
      id: data?.id,
      formId: data?.formId,
    };
  }

  const changeCertificationHandler = (radioValue) => {
    postScores(radioValue);
  };
  const postScores = async (radioValue) => {
    const postScoringURL = `${process.env.REACT_APP_SERVER_URL}/api/scoring/change_fssc_reccomendation`;
    const token = await getToken();
    setScoringLoading(true);
    try {
      const response = await axios.post(
        postScoringURL,
        {
          formId: auditNumber,
          newRecommendationFssc:
            radioValue
        },
        {
          headers: {
            "oidc-token": token,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 201) {
        const data = response.data;
        setScoringData((prev) => ({
          ...prev,
          auditConclusion: {
            ...prev.auditConclusion,
            conformanceLevel: data.conformanceLevel,
            isFfscCertificationRecommended:
              radioValue
          },
        }));
        setScoringLoading(false);
      } else {
        setScoringError("Oops! Something went wrong. . .");
      }
    } catch (e) {
      setScoringLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setScoringError("Oops! Something went wrong. . .");
    } finally {
      setScoringError(false);
    }
  };

  const getScoringDetails = async () => {
    const getScoringURL = `${process.env.REACT_APP_SERVER_URL}/api/scoring/get_score/${auditNumber}`;
    const token = await getToken();
    setScoringLoading(true);
    try {
      const response = await axios.get(getScoringURL, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        setScoringData(response.data);
        setScoringLoading(false);
        let fsscArr = transformData(response?.data?.fsscScore);
        setFsscScore(fsscArr);
        let qmsArr = transformData(response?.data?.qmsScore);
        setQmsScore(qmsArr);
        if (response?.data?.isFsscConjuction) {
          setIsCertification(response?.data?.isFsscConjuction);
        }
        setLoading(false);
      } else {
        setScoringError("Oops! Something went wrong. . .");
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      setScoringLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setScoringError("Oops! Something went wrong. . .");
    } finally {
      setScoringError(false);
    }
  };
    const unitDetailsInfo = async () => {
      const viewUrl = `${process.env.REACT_APP_SERVER_URL}/super/view_forms/${auditNumber}`;
      const token = await getToken();
      try {
        setLoading(true);
        const response = await axios.get(viewUrl, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
        if (response.status === 200) {
          const data = response.data;
          const unit_index = data?.unitIndex;
          const combinedData = [
            ...data.unitDetails.unitDetails,
            ...data.unitDetails.offSiteFields
          ]
          if(combinedData){
            setUnitDetails(combinedData)
          }
          if(unit_index){
            setUnitIndex(unit_index)
          }
  
          console.log("combine data", combinedData)
  
  
        }
      } catch (e) {
        const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
        console.log("getting error while calling the api");
      }
    };

  const getAuditDetailsData = async () => {
    try {
      // setloading(true);

      const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit/${auditNumber}`;
      const token = await getToken();

      const response = await axios.get(url, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        if (json) {
          setAuditDetailsData(json);
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      // setloading(false);
    }
  };

  const getProtocolData = async () => {
    try {
      setLoading(true);

      if (auditNumber) {
        let url;
        if (getSotredProtocolType === "Full Scope") {
          url = `${process.env.REACT_APP_SERVER_URL}/api/protocol/get_fullscope/${auditNumber}`;
        } else if (getSotredProtocolType === "Gap Assessment") {
          url = `${process.env.REACT_APP_SERVER_URL}/api/protocol/get_gap_assessment/${auditNumber}`;
        } else if (getSotredProtocolType === "Addendum") {
          url = `${process.env.REACT_APP_SERVER_URL}/api/protocol/get_addendum/${auditNumber}`;
        } else {
          url = "invalidurl";
        }
        const token = await getToken();

        const response = await axios.get(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });

        if (response.status === 200) {
          const json = response.data;

          if (json) {
            // setFormData(json);
            setProtocolDetailsData(json);
          }
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      setLoading(false);

      // setloading(false);
    }
  };

  useEffect(() => {
    getScoringDetails();
    getAuditDetailsData();
    getProtocolData();
    unitDetailsInfo();
  }, []);
  useEffect(() => {
    let attendiesDetails = auditDetailsData?.audit_team || {};

    // Validate if attendiesDetails is not an empty object
    const result =
      Object.keys(attendiesDetails).length > 0
        ? Object.keys(attendiesDetails).map((key) => ({
            name: key, // Use the key as the name
            function: attendiesDetails[key],
          }))
        : []; // If it's empty, return an empty array

    // Set the result to state
    setAttendiesInArrayFormat(result);
  }, [scoringData, auditDetailsData]);

  console.log("audit page data", auditDetailsData);
  console.log("protocolDetailsData", protocolDetails);
  return (
    <>
      {loading ? (
        <Modal open={loading}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh", // Full viewport height
              width: "100%",
              flexDirection: "column",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
              backdropFilter: "blur(5px)", // Adding a blur effect for the background
              borderRadius: "10px", // Rounded corners
              padding: "20px",
            }}
          >
            <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
            <h3
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              Loading... Please wait
            </h3>
          </Box>
        </Modal>
      ) : (
        <>
          {scoringSubmitValue ? (
            <div className="submitGif-box">
              <img src={submitGif} alt="submitgif" />
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "right",
                  paddingBottom: "10px",
                }}
              >
                <AuditProtocolScoringExcel
                  auditData={auditDetailsData}
                  protocolData={protocolDetails}
                  fileName={`${unitIndex}_${auditNumber}_${new Date().getTime()}`}
                  // // transformData={transformData}
                  sheetNames={[
                    "Unit Details",
                    "Audit details",
                    "Protocol details",
                    "Scoring details",
                    "Areas of Concern",
                    "PY-Areas of Concern",
                    "FSSC Findings",
                    "PY-FSSC Findings",
                  ]}
                  color="ff8200"
                  // exportPosition={true}
                  className="export-btn"
                  scoringData={scoringData}
                  protocolType={getSotredProtocolType}
                  auditFocusArea={auditDetailsData?.audit_focus_area}
                  protocolFocusArea={protocolDetails?.focusArea}
                  additionalAttendees={attendiesInArrayFormat}
                  isCertification={isCertification}
                  unitDetails = {unitDetails}
                  
                />
              </div>
              <div id="main-scoring-details">
                <TopSection
                  fsscScore={fsscScore}
                  qmsScore={qmsScore}
                  scoringLoading={scoringLoading}
                  onChangeCertification={changeCertificationHandler}
                  isCertification={isCertification}
                  protocolDetails={protocolDetails}
                  scoringData={scoringData?.auditConclusion}
                />
                <BottomSection
                  scoringData={scoringData?.auditConclusion}
                  setScoringData={setScoringData}
                  scoringLoading={scoringLoading}
                  auditNumber={auditNumber}
                />
              </div>
            </>
          )}
        </>
      )}
      
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default ScoringDetails;
